export function deg2Rad(val: number): number {
    return val * (Math.PI / 180);
}

export function squareOf(val: number): number {
    return Math.pow(val, 2);
}

/**
 * Calculate the distance between two sets of latitude and longitude coordinates in meters.
 *
 * @param {number} lastLatitude - the latitude of the starting point
 * @param {number} lastLongitude - the longitude of the starting point
 * @param {number} actualLatitude - the latitude of the end point
 * @param {number} actualLongitude - the longitude of the end point
 * @return {number} the distance in meters between the two points
 */
export function getDistance(
    lastLatitude: number,
    lastLongitude: number,
    actualLatitude: number,
    actualLongitude: number,
): number {
    const firstLatitude: number = deg2Rad(lastLatitude);
    const firstLongitude: number = deg2Rad(lastLongitude);
    const secondLatitude: number = deg2Rad(actualLatitude);
    const secondLongitude: number = deg2Rad(actualLongitude);

    const dLat: number = secondLatitude - firstLatitude;
    const dLng: number = secondLongitude - firstLongitude;
    const a: number =
        squareOf(Math.sin(dLat / 2)) +
        Math.cos(firstLatitude) * Math.cos(secondLatitude) * squareOf(Math.sin(dLng / 2));

    const c: number = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const R = 6372.797; // radius of the earth in KMs
    const distanceInKms: number = R * c;

    return distanceInKms * 1000;
}
